// FT-018: единый source of truth для default API base URL.
//
// Resolution chain:
// 1. Build-time ENV (VUE_APP_API_URL из .env.development / .env.staging /
//    .env.production) — используется когда region payload ещё не получен
//    (pre-login или для standalone uppy companion endpoints).
// 2. Hardcoded fallback per NODE_ENV — для backward-compat со старыми
//    builds где .env.* пустой (legacy).
//
// Post-review fix (architect-review P0): production NODE_ENV без VUE_APP_API_URL
// = misconfigured build, потенциально cross-contaminates regions (например,
// staging build без .env.staging.local пойдёт на rentprog.net). console.error
// делает это заметным в console сразу после bundle load — не silent fall.
//
// Используется:
// - В Vue components: this.$store.getters.getApiUrl (предпочитает state.api_url
//   из login response, fallback на DEFAULT_API_BASE).
// - В plain JS / non-component code: import { DEFAULT_API_BASE } from "@/utils/apiBase".
// - В bootstrap (src/main.js) — defaultApiUrl computed inline (не imported из
//   этого файла потому что main.js boot-time, до module resolver setup).

const LEGACY_PRODUCTION_FALLBACK = "https://rentprog.net";

function resolveDefaultApiBase() {
  if (process.env.VUE_APP_API_URL) return process.env.VUE_APP_API_URL;
  // Development: хост из origin страницы — в браузере localhost, при
  // live-reload на устройстве LAN-IP мака (страница загружена с него же,
  // значит и Rails доступен там же, порт 3000). Убирает ручную правку
  // .env.development при каждой смене DHCP-адреса.
  if (process.env.NODE_ENV === "development") return `http://${window.location.hostname}:3000`;
  // eslint-disable-next-line no-console
  console.error(
    "[apiBase] VUE_APP_API_URL is empty in non-development build — " +
    "falling back to legacy production URL (" + LEGACY_PRODUCTION_FALLBACK + "). " +
    "If this is staging/EU/other region, the .env file is missing or build mode is wrong."
  );
  return LEGACY_PRODUCTION_FALLBACK;
}

export const DEFAULT_API_BASE = resolveDefaultApiBase();
